import { render, staticRenderFns } from "./TableStockoutIndex.vue?vue&type=template&id=87f89b54&scoped=true&"
import script from "./TableStockoutIndex.vue?vue&type=script&lang=js&"
export * from "./TableStockoutIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87f89b54",
  null
  
)

export default component.exports